var focusFirstItemInSection = function focusFirstItemInSection(currentElement) {
  var _a, _b;
  var items = (_b = (_a = currentElement.closest('.cogs-lab-select-panel__section')) === null || _a === undefined ? undefined : _a.querySelectorAll('li.cogs-lab-select-panel__menu-item')) !== null && _b !== undefined ? _b : [];
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    if (item.classList.contains('cogs-lab-select-panel__menu-item--disabled')) continue;
    item.focus();
    break;
  }
};
var focusLastItemInSection = function focusLastItemInSection(currentElement) {
  var _a, _b;
  var items = (_b = (_a = currentElement.closest('.cogs-lab-select-panel__section')) === null || _a === undefined ? undefined : _a.querySelectorAll('li.cogs-lab-select-panel__menu-item')) !== null && _b !== undefined ? _b : [];
  for (var i = items.length - 1; i > -1; i--) {
    var item = items[i];
    if (item.classList.contains('cogs-lab-select-panel__menu-item--disabled')) continue;
    item.focus();
    break;
  }
};
var _focusPrevItem = function focusPrevItem(currentElement) {
  var _a;
  var prevItem = getPrevSiblingOrCousin(currentElement);
  if (prevItem === null || prevItem === undefined ? undefined : prevItem.classList.contains('cogs-lab-select-panel__menu-item--disabled')) return _focusPrevItem(prevItem);
  if (prevItem) {
    prevItem.focus();
    return;
  }
  var prevSection = (_a = currentElement.closest('.cogs-lab-select-panel__section')) === null || _a === undefined ? undefined : _a.previousElementSibling;
  if (prevSection === null || prevSection === undefined ? undefined : prevSection.classList.contains('cogs-lab-select-panel__section')) {
    var firstItemPrevSection = prevSection.querySelector('li.cogs-lab-select-panel__menu-item:last-child');
    if (firstItemPrevSection === null || firstItemPrevSection === undefined ? undefined : firstItemPrevSection.classList.contains('cogs-lab-select-panel__menu-item--disabled')) return _focusPrevItem(firstItemPrevSection);
    firstItemPrevSection === null || firstItemPrevSection === undefined ? undefined : firstItemPrevSection.focus();
    return;
  }
};
var _focusNextItem = function focusNextItem(currentElement) {
  var _a;
  var nextItem = getNextSiblingOrCousin(currentElement);
  if (nextItem === null || nextItem === undefined ? undefined : nextItem.classList.contains('cogs-lab-select-panel__menu-item--disabled')) return _focusNextItem(nextItem);
  if (nextItem) {
    nextItem.focus();
    return;
  }
  var nextSection = (_a = currentElement.closest('.cogs-lab-select-panel__section')) === null || _a === undefined ? undefined : _a.nextElementSibling;
  if (nextSection === null || nextSection === undefined ? undefined : nextSection.classList.contains('cogs-lab-select-panel__section')) {
    var firstItemNextSection = nextSection.querySelector('li.cogs-lab-select-panel__menu-item:first-child');
    if (firstItemNextSection === null || firstItemNextSection === undefined ? undefined : firstItemNextSection.classList.contains('cogs-lab-select-panel__menu-item--disabled')) return _focusNextItem(firstItemNextSection);
    firstItemNextSection === null || firstItemNextSection === undefined ? undefined : firstItemNextSection.focus();
    return;
  }
};
var getNextSiblingOrCousin = function getNextSiblingOrCousin(currentElement) {
  var _a, _b;
  var items = Array.from((_b = (_a = currentElement.closest('.cogs-lab-select-panel__body-wrapper')) === null || _a === undefined ? undefined : _a.querySelectorAll('.cogs-lab-select-panel__section li.cogs-lab-select-panel__menu-item')) !== null && _b !== undefined ? _b : []);
  var nextSibling = null;
  for (var i = 0; i < items.length; i++) {
    if (items[i] === currentElement) if (i < items.length - 1) {
      nextSibling = items[i + 1];
      break;
    }
  }
  return nextSibling;
};
var getPrevSiblingOrCousin = function getPrevSiblingOrCousin(currentElement) {
  var _a, _b;
  var items = Array.from((_b = (_a = currentElement.closest('.cogs-lab-select-panel__body-wrapper')) === null || _a === undefined ? undefined : _a.querySelectorAll('.cogs-lab-select-panel__section li.cogs-lab-select-panel__menu-item')) !== null && _b !== undefined ? _b : []).reverse();
  var nextSibling = null;
  for (var i = 0; i < items.length; i++) {
    if (items[i] === currentElement) if (i < items.length - 1) {
      nextSibling = items[i + 1];
      break;
    }
  }
  return nextSibling;
};

export { focusFirstItemInSection, focusLastItemInSection, _focusNextItem as focusNextItem, _focusPrevItem as focusPrevItem, getNextSiblingOrCousin, getPrevSiblingOrCousin };
